import { PropsWithChildren } from "react";
import { cn } from "@/lib";

interface MainContainerProps {
  className?: string;
  innerClassName?: string;
}

export const MainContainer = ({
  children,
  className,
  innerClassName,
}: PropsWithChildren<MainContainerProps>) => {
  return (
    <div
      className={cn(
        "flex flex-1 flex-col min-h-0 justify-center w-full overflow-hidden",
        className,
      )}
    >
      <div
        className={cn(
          "w-full flex-1 min-h-0 overflow-auto flex flex-col px-2 lg:px-6",
          innerClassName,
        )}
      >
        {children}
      </div>
    </div>
  );
};
